import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
const CardSkeleton = ({ sx }) => {
	return (
		<Box sx={{ minWidth: "50rem", height: "48rem", ...sx }}>
			<Skeleton sx={{ width: "100%", height: "100%" }} variant="rectangular" animation="wave" />
		</Box>
	);
};

export default CardSkeleton;
